import React from 'react';
import styled from '@emotion/styled';
import { RefreshCw, History, Bot } from 'lucide-react';

const Sidebar = styled.div`
  width: 280px;
  background: #f8fafc;
  border-right: 1px solid #e5e7eb;
  padding: 1.5rem;
  overflow-y: auto;
`;

const SidebarSection = styled.div`
  margin-bottom: 2rem;
  
  &:last-child {
    margin-bottom: 0;
  }
`;

const SidebarTitle = styled.h3`
  margin: 0 0 1rem 0;
  font-size: 0.875rem;
  font-weight: 600;
  color: #374151;
  text-transform: uppercase;
  letter-spacing: 0.05em;
`;

const SidebarItem = styled.button`
  width: 100%;
  display: flex;
  align-items: center;
  gap: 0.75rem;
  padding: 0.75rem;
  border: none;
  background: ${props => props.active ? '#eff6ff' : 'transparent'};
  border-radius: 6px;
  color: ${props => props.active ? '#1d4ed8' : '#374151'};
  font-size: 0.875rem;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s;
  text-align: left;
  margin-bottom: 0.25rem;
  
  &:hover {
    background: ${props => props.active ? '#eff6ff' : '#f3f4f6'};
  }
`;

const FieldModalSidebar = ({ activeSection, onSectionChange, displayMatchStatus }) => {
  return (
    <Sidebar>
      <SidebarSection>
        <SidebarTitle>Navigation</SidebarTitle>
        <SidebarItem 
          active={activeSection === 'matching'}
          onClick={() => onSectionChange('matching')}
        >
          <RefreshCw size={16} />
          Matching
        </SidebarItem>
        {(displayMatchStatus === 'maybe' || displayMatchStatus === 'mismatch') && (
          <SidebarItem 
            active={activeSection === 'analysis'}
            onClick={() => onSectionChange('analysis')}
            style={{ position: 'relative' }}
          >
            <div style={{
              display: 'flex',
              alignItems: 'center',
              gap: '0.75rem'
            }}>
              <div style={{
                width: '24px',
                height: '24px',
                backgroundColor: '#f59e0b',
                borderRadius: '50%',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center'
              }}>
                <Bot size={16} style={{ color: 'white' }} />
              </div>
              <span>Analysis</span>
            </div>
          </SidebarItem>
        )}
        <SidebarItem 
          active={activeSection === 'history'}
          onClick={() => onSectionChange('history')}
          data-cy="field-history-tab"
        >
          <History size={16} />
          History
        </SidebarItem>
      </SidebarSection>
    </Sidebar>
  );
};

export default FieldModalSidebar;

